import './comingSoon.css';

export default function ComingSoon() {
  return (
    <div className="coming-page">
      <div className="orbit">
        <div className="planet"></div>
        <div className="ring"></div>
        <div className="satellite"></div>
      </div>
      <div className="text-block">
        <p className="eyebrow">Stats Hub</p>
        <h1>Coming Soon</h1>
        <p className="subhead">
          We’re crafting a rich stats experience with AI-driven insights, live metrics, and clean visuals.
          Stay tuned for launch.
        </p>
      </div>
    </div>
  );
}
